angular.module('jv.sendSMSMessage.controller', [])
    .controller('jvSendSMSMessageController', [
        '$scope', '$rootScope', 'TemplateLoader', 'jvCandidatesService', '$q', '$jobviteUrls', '$timeout', 'jvHireBroadcastSVC',
        function($scope, $rootScope, TemplateLoader, jvCandidatesService, $q, $jobviteUrls, $timeout, jvHireBroadcastSVC) {
            jvHireBroadcastSVC.subscribe('showSendSMSMessageModal', function(event, value) {
                $scope.action = 'sendSMSMessage';
                $scope.validateCandidatePhoneDetails(value);
                $scope.getPhoneNoList();

            });
            $scope.jvUrls = $jobviteUrls;
            var i18n;
            if ($.isEmptyObject($scope.i18n)) {
                //Candidate list page does not have i18n
                i18n = {
                    TO: 'To',
                    TEMPLATE: 'Template',
                    SUBJECT: 'Subject',
                    MESSAGE: 'Message',
                    SEND_SMS_MESSAGE: 'Send SMS Message'
                };
            } else {
                i18n = angular.copy($scope.i18n);
            }

            $scope.CandidateListPage = false;
            $scope.CandidateDetailsPage = false;

            $scope.modals = {
                sendMessageValidation: {
                    show: false
                },
                sendSMSMessage: {
                    show: false
                }
            };

            var getmodalConfig = function(action) {
                var qsParams = {};
                $scope.sendSMSMessageModalConfig = {
                    resetModalOn: 'modals.sendSMSMessage.show',
                    to: {
                        label: i18n['TO'],
                        type: 'readOnlyLink',
                        data: {
                            type: 'link',
                            text: $scope.toList
                        },
                        responseKey: 'employees',
                    },
                    templates: {
                        type: 'dropDown',
                        get: {
                            url: $scope.jvUrls.jhire + '/action/application/template/sendSMSMessage?{0}'.format($.param(qsParams)),
                            transform: function(templateData) {
                                var cont = templateData.content;
                                for (var i = 0; i < cont.length; i++) {
                                    cont[i].EId = i + 1;
                                }
                                return $scope.select2Options.setTemplates(templateData);
                            }
                        },
                        responseKey: 'templates',
                        label: i18n['TEMPLATE'],
                        optionText: 'title',
                        post: {
                            callBack: $scope.sendSMSMessage,
                            button: {
                                label: i18n['SEND_MESSAGE'],
                                type: 'button',
                                classNames: ['blue-btn', 'float-right'],
                                id: 'send-msg-btn'
                            }
                        }
                    },
                    from: [{
                        label: i18n['FROM'],
                        required: true,
                        errorText: i18n['JV_SENDMESSAGE_CONTROLLER_THIS_IS_A_REQUIRED_FIELD'],
                        data: {
                            type: 'dropDown',
                            key: 'sendMsgFrom',
                            name: 'fromList',
                            optionsValues: [

                            ]
                        }
                    }],
                    subject: {
                        isSms:true
                    },
                    scheduledSMS: {
                        label: i18n['SCHEDULE_SMS'],
                        errorText: i18n['JV_SENDSMSMESSAGE_CONTROLLER_SCHEDULED_SMS_TIME'],
                        dateTime: {
                            errorText: i18n['JV_SENDSMSMESSAGE_CONTROLLER_DATETIME_IS_REQUIRED'],
                        }
                    },
                    message: {
                        required: true,
                        plainTextEditor: true,
                        errorText: i18n['JV_SENDMESSAGE_CONTROLLER_THIS_IS_A_REQUIRED_FIELD'],
                        label: i18n['MESSAGE'],
                        mergeFields: [{
                                label: 'Candidate Name',
                                value: '[candidateName]'
                            },
                            {
                                label: 'Candidate First Name',
                                value: '[candidateFirstName]'
                            },
                            {
                                label: 'Candidate Last Name',
                                value: '[candidateLastName]'
                            },
                            {
                                label: 'Recruiter First Name',
                                value: '[recruiterFirstName]'
                            },
                            {
                                label: 'Recruiter Last Name',
                                value: '[recruiterLastName]'
                            }
                        ]
                    }

                }; //end config object

                return $scope.sendSMSMessageModalConfig;

            };

            var setupFormTemplateConfig = function(action) {
                //FormTemplateConfig
                $scope.formTemplateConfig = getmodalConfig(action);
            };

            $scope.showModals = function(modal, skipConfigSetup, errMsgData) {
                if (!skipConfigSetup) {
                    setupFormTemplateConfig(modal);
                }
                TemplateLoader.load(modal).then(function() {
                    $scope.modals[modal].show = true;
                    if (errMsgData) {
                        $scope.modals[modal].errMsg = errMsgData;
                    }
                });
            };

            $scope.hideModals = function() {
                angular.forEach($scope.modals, function(val, key) {
                    $scope.modals[key].show = false;
                });
            };

            $scope.templates = TemplateLoader.register({
                sendSMSMessage: '/jhire/modules/candidates/modals/sendSMSMessage.html',
                sendMessageValidation: '/jhire/modules/candidates/modals/sendMessageValidation.html',
            });

            $scope.getPhoneNoList = function() {
                jvCandidatesService.getPhoneNoList({
                    data: {}
                }, function(resp) {
                    if (resp && resp.data && resp.data.phoneList && resp.data.phoneList.content) {
                        var phoneListContent = resp.data.phoneList.content;
                        var fromObj = $scope.sendSMSMessageModalConfig.from[0];
                        fromObj.data.optionsValues = [];
                        for (var phone of phoneListContent) {
                            // phoneForDisplay
                            const phoneData = {
                                label: phone.channelKey,
                                checked: true,
                                displayName: [phone.owner.displayName, phone.phoneForDisplay].join(' '),
                                value: phone.channelKey
                            }
                            fromObj.data.optionsValues.push(phoneData);
                        }
                    } else {
                        $scope.hideModals();
                        $scope.showModals('sendMessageValidation', true, i18n['CANDIDATE_SEND_SMS_PHONENUMBER_VALIDATION']);
                    }
                });

            }
            $scope.validateCandidatePhoneDetails = function(data) {
                var postData = {};
                postData.action = 'sendSMSMessage';
                if (data) {
                    postData.data = data.appIds;
                    $scope.appIds = postData.data;
                    $scope.isMultipleApplicationsSelected = postData.data.length > 1 ? true : false;
                }
                jvCandidatesService.validateCandidatePhoneDetails(postData, function(response) {
                    if (response && response.status === 200) {
                        var validationResult = $scope.validationResult = response.data;
                        validationResult.validApplicationCountLink = '';
                        validationResult.invalidApplicationCountLink = '';
                        if (response.data.validApplicationIds) {
                            if (response.data.validApplicationIds.length === 0) {
                                $scope.showModals('sendMessageValidation', true);
                                return false;
                            }
                        }

                        if (validationResult.validApplicationCount) {
                            validationResult.validApplicationCountLink = validationResult.validApplicationCount + ' ' + i18n['CANDIDATES_COMMON'];
                        }
                        if (validationResult.invalidApplicationCount) {
                            validationResult.invalidApplicationCountLink = validationResult.invalidApplicationCount + ' ' + i18n['CANDIDATES_COMMON'];
                            validationResult.skipMissingPhoneNumbers = i18n['CANDIDATES_MISSING_PHONENUMBER'];
                        }
                        $scope.validApplicationIds = response.data.validApplicationIds;
                        $scope.showModals($scope.action);
                    }
                });
            };
            $scope.sendSMSMessage = function(modalData) {
                $scope.hideModals();
                modalData.sendSMSMsgFrom = modalData.sendMsgFrom.replace(/\s+/g, '');
                var toList = $scope.validApplicationIds.map(appId => {
                    return {
                        'refKey': 'candidate|' + appId
                    }
                });
                var data = {
                    candidateList: toList,
                    message: {
                        body: modalData.msgDataItem.body,
                        channelKey: modalData.sendSMSMsgFrom
                    },
                    scheduledSendDateTime: modalData.msgDataItem.scheduledSMS
                };
                $scope.flags.loading = true;

                jvCandidatesService.sendSMSMessage(data, function(response) {
                    if (response && response.status === 200) {
                        $rootScope.$broadcast('sendSMSMessageSuccess', true);
                    } else {
                        $rootScope.error = i18n.UNABLE_TO_SEND_SMS_MESSAGES + response.status;
                    }
                }, function(fail) {
                    $scope.flags.loading = false;
                });
            };
        }
    ]);